<div class="crewrepeater" *ngFor="let crewbio of cruisebios; let i=index;">
    <div class="borderaround" *ngIf="crewbio.crlOBPortalPhoneDisp">
        <div>

            <a *ngIf="!crewbio.expander" (click)="crewbio.expander = !crewbio.expander"><i
                    class="fa-solid fa-circle-plus fa-lg"></i><span class="action">{{crewbio.crewRole}}, <span
                        class="officername">{{crewbio.crwName}}</span></span></a>
            <a *ngIf="crewbio.expander" (click)="crewbio.expander = !crewbio.expander"><i
                    class="fa-solid fa-circle-minus fa-lg"></i><span class="action">{{crewbio.crewRole}}</span></a>
        </div>
        <div class="row innerexpand" *ngIf="crewbio.expander">
            <div class="col-6">
                <div class="officername">{{crewbio.crwName}}</div>
                <div class="officerphone"><a href="tel:{{crewbio.spcPhoneNumber}}">{{crewbio.spcPhoneNumber |
                        phoneFormat}}</a>
                </div>

            </div>
            <div class="col-6">
                <div class="officerpic">
                    <img src="{{imagepath}}bioimages/{{crewbio.crbBioImageLink}}" alt=""
                        onerror="this.style.display='none'" class="img-fluid">
                </div>

            </div>
        </div>
    </div>
    <div class="twentypxtop" *ngIf="crewbio.crlOBPortalPhoneDisp"></div>
</div>